import { Component } from '@angular/core';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [],
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss'
})
export class CallbackComponent {
  ngOnInit(): void {
   console.log("xxxxxx")
  }
}
